// extracted by mini-css-extract-plugin
export default {"container":"uId13FlWcataHa_TsFaF","heading":"wnSG1CRrJK3nkXDqacST","content":"IdeM2MPFRs6vZ9K4UwWy","item":"AvfIzfig2Yz8KvwroVFS"};